var _sodipodiNamedview, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 328.846 328.846",
    id: "svg2971",
    x: "0px",
    y: "0px",
    width: "328.846px",
    height: "328.846px",
    enableBackground: "new 0 0 328.846 328.846",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    showgrid: "false",
    inkscapeCy: 240.65549,
    inkscapeCx: 59.947345,
    inkscapeZoom: 1.3083681,
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    id: "base",
    "inkscapeSnap-bbox": "true",
    "inkscapeSnap-global": "true",
    "inkscapeSnap-bbox-midpoints": "true",
    "inkscapeSnap-smooth-nodes": "true",
    "inkscapeGuide-bbox": "true",
    "inkscapeSnap-object-midpoints": "true",
    "inkscapeObject-nodes": "true",
    "inkscapeBbox-paths": "true",
    "inkscapeSnap-center": "true",
    "inkscapeObject-paths": "true",
    "inkscapeBbox-nodes": "true",
    "fit-margin-left": 0,
    "fit-margin-top": 0,
    "inkscapeWindow-height": 1018,
    "inkscapeWindow-width": 1920,
    inkscapePageshadow: 2,
    "inkscapeCurrent-layer": "layer1",
    "inkscapeWindow-x": -8,
    "inkscapeWindow-y": -8,
    "inkscapeWindow-maximized": 1,
    inkscapePageopacity: 0,
    "fit-margin-bottom": 0,
    "fit-margin-right": 0,
    "inkscapeSnap-intersection-paths": "true",
    "inkscapeSnap-bbox-edge-midpoints": "true",
    showguides: "true",
    "inkscapeDocument-units": "px"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("inkscapePerspective", {
    id: "perspective2979",
    sodipodiType: "inkscape:persp3d",
    inkscapeVp_z: "744.09448 : 526.18109 : 1",
    inkscapeVp_x: "0 : 526.18109 : 1",
    inkscapeVp_y: "0 : 1000 : 0",
    "inkscapePersp3d-origin": "372.04724 : 350.78739 : 1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-204.03606,314.80785)",
    inkscapeLabel: "Calque 1",
    inkscapeGroupmode: "layer"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 253.276,
    y: -265.568,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 214.2572 216.4927)",
    fill: "#FFFFFF",
    width: 230.365,
    height: 230.366
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3080",
    "inkscapeConnector-curvature": 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.9843,
    strokeDasharray: "1.9843,1.9843",
    d: " M367.742-101.136h45.497"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3082",
    "inkscapeConnector-curvature": 0,
    fill: "none",
    stroke: "#000000",
    strokeWidth: 1.9843,
    strokeDasharray: "1.9843,1.9843",
    d: " M362.32-115.662l69.52-0.001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3084",
    "inkscapeConnector-curvature": 0,
    d: "M308.62-100.248h1.984l0.673-1.984h3.331l0.673,1.984h2.02l-3.331-8.895 h-1.984L308.62-100.248z M312.942-106.946h0.035l1.134,3.26h-2.303L312.942-106.946z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3086",
    "inkscapeConnector-curvature": 0,
    d: "M325.911-106.131c-0.142-1.063-0.567-1.842-1.275-2.409 c-0.708-0.531-1.56-0.779-2.551-0.815c-1.382,0.036-2.48,0.461-3.224,1.348c-0.78,0.885-1.134,2.019-1.169,3.365 c0.035,1.312,0.389,2.375,1.169,3.26c0.744,0.886,1.842,1.346,3.224,1.347c2.268-0.071,3.579-1.275,3.898-3.649l-1.914-0.001 c-0.071,0.604-0.248,1.099-0.602,1.453c-0.319,0.354-0.815,0.532-1.382,0.567c-0.886-0.035-1.489-0.354-1.878-0.957 c-0.39-0.602-0.567-1.275-0.567-2.02c0-0.814,0.177-1.523,0.567-2.125c0.39-0.604,0.992-0.922,1.878-0.922 c0.496-0.001,0.921,0.141,1.275,0.426c0.354,0.283,0.567,0.672,0.638,1.133H325.911z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3088",
    "inkscapeConnector-curvature": 0,
    d: "M329.277-100.248h1.949v-7.229h2.657l0-1.666h-7.3l0,1.666h2.693V-100.248 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3090",
    "inkscapeConnector-curvature": 0,
    d: "M334.911-100.248l1.949-0.001v-8.894h-1.949V-100.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3092",
    "inkscapeConnector-curvature": 0,
    d: "M345.647-109.143l-2.02-0.001l-1.984,6.272h-0.036l-1.984-6.272 l-2.02,0.001l2.905,8.895h2.197L345.647-109.143z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3094",
    "inkscapeConnector-curvature": 0,
    d: "M346.427-100.248h1.949l0-8.896h-1.948V-100.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3096",
    "inkscapeConnector-curvature": 0,
    d: "M352.06-100.248h1.949v-7.229l2.658-0.001v-1.665h-7.265v1.665 l2.658,0.001V-100.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3098",
    "inkscapeConnector-curvature": 0,
    d: "M359.997-100.248h1.949l0-3.403l3.296-5.491h-2.162l-2.09,3.508l0,0 l-2.055-3.508l-2.197-0.001l3.259,5.422L359.997-100.248z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3100",
    "inkscapeConnector-curvature": 0,
    d: "M300.576-120.41c-0.142-1.027-0.567-1.772-1.275-2.338 c-0.674-0.496-1.524-0.78-2.48-0.78c-1.347,0-2.41,0.461-3.153,1.312c-0.744,0.85-1.135,1.949-1.134,3.26 c0,1.311,0.39,2.374,1.134,3.224c0.743,0.851,1.807,1.312,3.153,1.312c2.232-0.07,3.508-1.24,3.826-3.543h-1.877 c-0.071,0.566-0.249,1.027-0.567,1.382c-0.354,0.354-0.815,0.531-1.382,0.567c-0.851-0.037-1.453-0.32-1.843-0.922 c-0.354-0.603-0.531-1.24-0.531-2.02c0-0.779,0.177-1.489,0.531-2.055c0.39-0.604,0.992-0.888,1.842-0.922 c0.461,0,0.886,0.142,1.276,0.426c0.319,0.283,0.531,0.673,0.603,1.098H300.576z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3102",
    "inkscapeConnector-curvature": 0,
    d: "M301.568-118.957c0,1.311,0.39,2.374,1.134,3.224 c0.744,0.851,1.771,1.312,3.118,1.312c1.382,0,2.445-0.461,3.153-1.311c0.744-0.851,1.134-1.914,1.134-3.225 s-0.39-2.411-1.134-3.26c-0.708-0.851-1.771-1.312-3.153-1.312c-1.346,0-2.374,0.461-3.118,1.312 C301.958-121.367,301.568-120.268,301.568-118.957z M303.482-118.957c-0.036-0.779,0.142-1.488,0.531-2.055 c0.354-0.604,0.992-0.887,1.807-0.922c0.885,0.035,1.488,0.318,1.842,0.922c0.354,0.565,0.532,1.275,0.532,2.055 s-0.177,1.417-0.532,2.02c-0.354,0.603-0.957,0.886-1.842,0.922c-0.815-0.037-1.453-0.319-1.807-0.922 C303.623-117.54,303.446-118.178,303.482-118.957z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3104",
    "inkscapeConnector-curvature": 0,
    d: "M311.419-114.636l1.771,0.001v-5.812l0.035,0.001l3.614,5.811h1.914 v-8.681h-1.772v5.812h-0.035l-3.649-5.812h-1.878L311.419-114.636z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3106",
    "inkscapeConnector-curvature": 0,
    d: "M322.368-114.635h1.913l0-7.086h2.587v-1.595h-7.122l0,1.595h2.622 L322.368-114.635z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3108",
    "inkscapeConnector-curvature": 0,
    d: "M327.894-114.635l6.591-0.001l0-1.593l-4.677-0.001v-2.126h4.216l0-1.487 l-4.216-0.001v-1.877h4.57l0-1.595h-6.485V-114.635z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3110",
    "inkscapeConnector-curvature": 0,
    d: "M335.797-114.635l1.771-0.001v-5.81h0.036l3.614,5.811l1.913-0.001l0-8.68 l-1.771-0.001v5.812h-0.036l-3.649-5.811l-1.878-0.001V-114.635z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3112",
    "inkscapeConnector-curvature": 0,
    d: "M346.745-114.636l1.914,0.001v-7.086h2.587v-1.596h-7.123v1.596h2.623 L346.745-114.636z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3114",
    "inkscapeConnector-curvature": 0,
    d: "M351.706-117.504c0.036,1.063,0.39,1.841,1.133,2.337 c0.709,0.497,1.595,0.745,2.587,0.745c1.169,0,2.091-0.283,2.693-0.814c0.603-0.497,0.922-1.17,0.922-1.984 c0-0.496-0.106-0.887-0.319-1.205c-0.177-0.318-0.425-0.566-0.744-0.744c-0.284-0.178-0.568-0.318-0.851-0.39 c-0.284-0.107-0.496-0.142-0.674-0.177c-1.063-0.284-1.771-0.496-2.126-0.639c-0.177-0.105-0.283-0.177-0.354-0.283 c-0.071-0.105-0.106-0.249-0.106-0.39c0-0.39,0.142-0.638,0.425-0.78c0.248-0.142,0.567-0.212,0.886-0.212 c0.46,0,0.85,0.071,1.169,0.248c0.319,0.213,0.496,0.531,0.532,1.063l1.877-0.001c-0.035-1.026-0.389-1.735-1.063-2.161 c-0.673-0.425-1.488-0.638-2.445-0.638c-0.814,0-1.559,0.212-2.197,0.638c-0.673,0.426-1.027,1.099-1.063,1.984 c0,0.39,0.106,0.744,0.248,1.027c0.142,0.248,0.354,0.495,0.602,0.674c0.248,0.176,0.496,0.354,0.815,0.461 c0.319,0.14,0.638,0.247,0.957,0.318c0.673,0.142,1.241,0.318,1.771,0.496c0.249,0.07,0.461,0.213,0.603,0.354 c0.142,0.142,0.213,0.354,0.212,0.603c0,0.213-0.071,0.39-0.177,0.496c-0.106,0.142-0.249,0.282-0.425,0.354 s-0.354,0.143-0.531,0.178c-0.212,0.035-0.39,0.034-0.567,0.035c-0.532,0-0.993-0.105-1.347-0.39 c-0.39-0.248-0.566-0.638-0.602-1.204H351.706z"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect3165",
    x: 253.276,
    y: -265.568,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 735.3369 3.8168)",
    fill: "none",
    stroke: "#000000",
    strokeWidth: 3.0595,
    strokeLinecap: "square",
    strokeDasharray: "12.2378,12.2378",
    strokeDashoffset: 7,
    width: 230.366,
    height: 230.365
  }), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot3042",
    transform: "matrix(10.809755,0,0,10.809755,-706.32777,-848.20696)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4444",
    d: "M91.237,66.647h0.314v-0.558h0.313c0.079,0,0.136,0.017,0.172,0.05c0.035,0.035,0.057,0.09,0.066,0.166 c0.007,0.057,0.012,0.117,0.018,0.178c0.005,0.029,0.009,0.058,0.015,0.086c0.004,0.028,0.01,0.054,0.018,0.078h0.314 c-0.014-0.02-0.024-0.046-0.03-0.076c-0.004-0.014-0.007-0.03-0.008-0.046c-0.004-0.013-0.006-0.028-0.008-0.044 c-0.007-0.068-0.012-0.125-0.015-0.172c-0.003-0.075-0.019-0.144-0.048-0.208c-0.031-0.063-0.084-0.105-0.16-0.126l0-0.004 c0.152-0.068,0.228-0.188,0.227-0.358c-0.001-0.112-0.039-0.205-0.112-0.279c-0.074-0.075-0.175-0.113-0.306-0.114h-0.771 L91.237,66.647z M91.552,65.463h0.344c0.143-0.001,0.215,0.064,0.216,0.197c-0.001,0.139-0.073,0.207-0.216,0.204h-0.344V65.463z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4446",
    d: "M92.458,66.647h0.317l0.112-0.318h0.534l0.107,0.318h0.326l-0.534-1.428H93L92.458,66.647z M93.155,65.571 h0.004l0.181,0.524h-0.37L93.155,65.571z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4448",
    d: "M93.907,66.647h0.616c0.217-0.001,0.38-0.071,0.488-0.208c0.107-0.132,0.16-0.303,0.16-0.514 c-0.002-0.238-0.064-0.415-0.185-0.532c-0.12-0.116-0.274-0.174-0.464-0.174h-0.616V66.647z M94.222,65.483h0.224 c0.155,0.001,0.263,0.044,0.324,0.128c0.06,0.084,0.089,0.199,0.088,0.344c0,0.078-0.009,0.144-0.028,0.198 c-0.018,0.056-0.045,0.101-0.08,0.134c-0.032,0.034-0.069,0.058-0.111,0.072c-0.044,0.016-0.09,0.024-0.136,0.024h-0.28 L94.222,65.483z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4450",
    d: "M95.315,66.647h0.314l0-1.428h-0.314V66.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4452",
    d: "M95.77,65.939c0.001,0.211,0.063,0.386,0.186,0.524c0.123,0.143,0.295,0.215,0.517,0.218 c0.224-0.003,0.397-0.075,0.518-0.218c0.121-0.139,0.182-0.313,0.184-0.524c-0.001-0.217-0.062-0.397-0.184-0.538 c-0.121-0.141-0.294-0.213-0.518-0.216c-0.221,0.003-0.393,0.075-0.517,0.216C95.833,65.542,95.771,65.721,95.77,65.939z  M96.083,65.939c-0.001-0.131,0.029-0.244,0.09-0.34c0.061-0.098,0.16-0.148,0.299-0.151c0.141,0.003,0.242,0.053,0.302,0.151 c0.057,0.096,0.086,0.209,0.086,0.34c0,0.122-0.029,0.232-0.086,0.328c-0.06,0.097-0.16,0.147-0.302,0.15 c-0.139-0.003-0.238-0.052-0.299-0.149C96.112,66.171,96.082,66.061,96.083,65.939z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4454",
    d: "M97.161,66.647h0.317l0.112-0.318l0.534,0l0.107,0.318h0.326l-0.534-1.428h-0.321L97.161,66.647z  M97.859,65.571h0.004l0.181,0.524h-0.37L97.859,65.571z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4456",
    d: "M99.866,65.699c-0.021-0.167-0.089-0.294-0.204-0.382c-0.113-0.087-0.25-0.131-0.411-0.132 c-0.221,0.003-0.394,0.075-0.517,0.216c-0.122,0.141-0.184,0.321-0.186,0.538c0.001,0.211,0.063,0.386,0.186,0.524 c0.123,0.143,0.295,0.215,0.517,0.218c0.368-0.01,0.577-0.204,0.628-0.584l-0.305,0c-0.012,0.096-0.044,0.172-0.098,0.229 c-0.055,0.059-0.13,0.089-0.226,0.09c-0.139-0.003-0.238-0.052-0.299-0.149c-0.061-0.096-0.091-0.206-0.09-0.328 c-0.001-0.131,0.029-0.244,0.09-0.34c0.061-0.098,0.16-0.148,0.299-0.151c0.079,0.001,0.149,0.025,0.208,0.07 c0.057,0.047,0.092,0.107,0.104,0.18H99.866z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4458",
    d: "M100.334,66.647h0.313v-1.164h0.429v-0.264h-1.17v0.264h0.428V66.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4460",
    d: "M101.167,66.647h0.314v-1.428h-0.314V66.647z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4462",
    d: "M102.822,65.219h-0.324l-0.322,1.004h-0.004l-0.318-1.004h-0.323l0.464,1.428h0.354L102.822,65.219z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4464",
    d: "M102.872,66.647h1.084v-0.264h-0.77v-0.351h0.691l0-0.244l-0.691,0v-0.306h0.754v-0.264h-1.068V66.647z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g429",
    transform: "matrix(3.8059094,0,0,-3.8059094,227.33578,-150.37734)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path431",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccc",
    fill: "#FFF600",
    d: "M0,0l37.44,37.38L74.4,0.24"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path441",
    "inkscapeConnector-curvature": 0,
    fill: "none",
    stroke: "#1F1A17",
    strokeWidth: 1.6442,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M406-54.834h-72.342v-39.459H406V-54.834L406-54.834z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path449",
    "inkscapeConnector-curvature": 0,
    fill: "none",
    stroke: "#1F1A17",
    strokeWidth: 1.8268,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M229.162-151.291h281.333"
  }), /*#__PURE__*/React.createElement("g", {
    id: "flowRoot3135",
    transform: "matrix(5.0186927,0,0,5.0186927,82.979377,-340.84335)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4381",
    "inkscapeConnector-curvature": 0,
    d: "M51.423,54.505h0.313l0-1.164h0.429v-0.264h-1.17v0.263h0.428 L51.423,54.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4383",
    "inkscapeConnector-curvature": 0,
    d: "M52.329,54.505l0.314,0l0-0.557l0.314,0c0.079,0,0.136,0.016,0.172,0.05 c0.035,0.035,0.057,0.09,0.066,0.166c0.006,0.057,0.012,0.117,0.018,0.178c0.005,0.029,0.009,0.058,0.015,0.086 c0.004,0.028,0.01,0.054,0.018,0.078l0.314,0c-0.014-0.02-0.024-0.046-0.03-0.076c-0.004-0.014-0.007-0.03-0.008-0.046 c-0.004-0.013-0.006-0.028-0.008-0.044c-0.007-0.068-0.012-0.125-0.015-0.172c-0.003-0.075-0.019-0.144-0.048-0.208 c-0.031-0.063-0.084-0.104-0.16-0.126l0-0.004c0.152-0.068,0.228-0.188,0.227-0.358c-0.001-0.112-0.039-0.205-0.112-0.279 c-0.074-0.075-0.176-0.113-0.306-0.114h-0.77L52.329,54.505z M52.644,53.322h0.344c0.143-0.001,0.215,0.064,0.216,0.197 c-0.001,0.139-0.073,0.206-0.216,0.204h-0.344V53.322z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4385",
    "inkscapeConnector-curvature": 0,
    d: "M53.623,54.505h0.317l0.112-0.319l0.534,0l0.107,0.318h0.326 l-0.534-1.428h-0.321L53.623,54.505z M54.32,53.429l0.004,0l0.181,0.525h-0.37L54.32,53.429z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4387",
    "inkscapeConnector-curvature": 0,
    d: "M55.146,54.505h0.294v-0.956h0.004l0.595,0.956h0.313v-1.428h-0.294 v0.958h-0.004l-0.596-0.958l-0.313,0V54.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4389",
    "inkscapeConnector-curvature": 0,
    d: "M56.536,54.032c0.004,0.175,0.066,0.302,0.186,0.384 c0.117,0.083,0.258,0.124,0.422,0.124c0.195-0.001,0.342-0.045,0.443-0.132c0.1-0.085,0.15-0.194,0.15-0.326 c-0.001-0.082-0.018-0.148-0.05-0.2c-0.033-0.052-0.074-0.093-0.122-0.122c-0.048-0.031-0.095-0.052-0.141-0.066 c-0.046-0.014-0.083-0.023-0.111-0.028c-0.173-0.043-0.289-0.078-0.347-0.104c-0.029-0.014-0.05-0.03-0.062-0.048 c-0.012-0.017-0.018-0.038-0.018-0.063c0.001-0.06,0.025-0.103,0.071-0.128c0.043-0.023,0.091-0.034,0.144-0.034 c0.077-0.002,0.143,0.012,0.195,0.042c0.052,0.032,0.081,0.09,0.086,0.174l0.305,0c-0.003-0.165-0.06-0.284-0.172-0.355 c-0.111-0.07-0.244-0.104-0.4-0.104c-0.135,0-0.256,0.035-0.362,0.106c-0.112,0.072-0.169,0.18-0.172,0.325 c0,0.066,0.013,0.121,0.038,0.166c0.024,0.046,0.056,0.084,0.097,0.114c0.041,0.029,0.087,0.054,0.138,0.074 c0.051,0.021,0.102,0.039,0.153,0.052c0.111,0.024,0.208,0.051,0.292,0.08c0.042,0.015,0.075,0.034,0.099,0.058 c0.023,0.025,0.034,0.058,0.034,0.098c0,0.036-0.009,0.065-0.026,0.086c-0.019,0.024-0.042,0.043-0.07,0.055 c-0.028,0.014-0.058,0.023-0.09,0.029c-0.032,0.005-0.062,0.008-0.092,0.008c-0.087,0-0.16-0.021-0.22-0.062 c-0.063-0.041-0.095-0.108-0.097-0.201L56.536,54.032z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4391",
    "inkscapeConnector-curvature": 0,
    d: "M57.923,54.505l0.314,0v-0.512h0.33c0.176-0.003,0.303-0.051,0.382-0.145 c0.075-0.089,0.112-0.194,0.112-0.313c0-0.122-0.037-0.228-0.112-0.318c-0.079-0.091-0.206-0.137-0.382-0.14l-0.645,0V54.505z  M58.237,53.322h0.244c0.077-0.001,0.141,0.011,0.193,0.038c0.054,0.028,0.081,0.087,0.082,0.176 c-0.001,0.088-0.028,0.146-0.082,0.174c-0.024,0.016-0.053,0.027-0.086,0.032c-0.033,0.005-0.069,0.008-0.107,0.008l-0.244,0 V53.322z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4393",
    "inkscapeConnector-curvature": 0,
    d: "M59.197,53.797c0.001,0.211,0.063,0.386,0.186,0.525 c0.123,0.142,0.295,0.215,0.516,0.218c0.224-0.003,0.397-0.075,0.518-0.218c0.121-0.139,0.182-0.313,0.184-0.524 c-0.001-0.217-0.062-0.397-0.184-0.538c-0.121-0.141-0.293-0.213-0.518-0.216c-0.221,0.003-0.393,0.075-0.516,0.216 C59.26,53.401,59.199,53.58,59.197,53.797z M59.511,53.797c-0.001-0.131,0.029-0.244,0.09-0.34c0.061-0.098,0.16-0.148,0.299-0.15 c0.141,0.003,0.242,0.053,0.302,0.15c0.057,0.096,0.086,0.209,0.086,0.34c0,0.123-0.028,0.232-0.086,0.328 c-0.06,0.097-0.161,0.147-0.302,0.15c-0.139-0.003-0.238-0.052-0.299-0.149C59.539,54.029,59.509,53.92,59.511,53.797z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4395",
    "inkscapeConnector-curvature": 0,
    d: "M60.813,54.505h0.314v-0.557l0.313,0c0.079,0,0.136,0.017,0.172,0.05 c0.035,0.034,0.057,0.09,0.067,0.166c0.006,0.057,0.012,0.117,0.018,0.178c0.005,0.029,0.009,0.058,0.015,0.086 c0.004,0.028,0.01,0.054,0.018,0.078l0.314,0c-0.014-0.02-0.024-0.046-0.03-0.076c-0.004-0.014-0.007-0.03-0.008-0.046 c-0.004-0.013-0.007-0.028-0.008-0.044c-0.007-0.068-0.012-0.125-0.015-0.172c-0.003-0.075-0.018-0.144-0.048-0.208 c-0.03-0.063-0.084-0.104-0.16-0.126v-0.004c0.152-0.068,0.228-0.188,0.226-0.358c-0.002-0.112-0.039-0.205-0.112-0.279 c-0.074-0.075-0.176-0.113-0.306-0.114h-0.771V54.505z M61.128,53.322l0.344,0c0.143-0.001,0.215,0.065,0.216,0.197 c-0.002,0.139-0.073,0.207-0.216,0.204l-0.344,0V53.322z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4397",
    "inkscapeConnector-curvature": 0,
    d: "M62.575,54.505l0.313,0v-1.164l0.429,0l0-0.264l-1.17,0v0.263l0.428,0 V54.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4399",
    "inkscapeConnector-curvature": 0,
    d: "M54.202,56.505h0.314l0-1.428h-0.315L54.202,56.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4401",
    "inkscapeConnector-curvature": 0,
    d: "M54.792,56.505h0.294l0-0.956h0.004l0.595,0.956h0.313v-1.428h-0.294 l0,0.958H55.7l-0.596-0.958h-0.313L54.792,56.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4403",
    "inkscapeConnector-curvature": 0,
    d: "M56.272,56.505h0.616c0.218-0.001,0.38-0.071,0.488-0.208 c0.107-0.132,0.16-0.303,0.16-0.514c-0.002-0.237-0.063-0.415-0.184-0.532c-0.12-0.116-0.274-0.174-0.464-0.174h-0.616V56.505z  M56.587,55.341h0.224c0.155,0.001,0.263,0.044,0.324,0.128c0.06,0.084,0.089,0.199,0.088,0.344c0,0.077-0.009,0.144-0.029,0.198 c-0.018,0.056-0.045,0.1-0.08,0.134c-0.032,0.034-0.069,0.058-0.111,0.072c-0.044,0.016-0.09,0.025-0.136,0.025h-0.28V55.341z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4405",
    "inkscapeConnector-curvature": 0,
    d: "M57.753,56.505h1.084v-0.264h-0.769v-0.351h0.691v-0.244h-0.691v-0.306 l0.754,0v-0.264h-1.068V56.505z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path4407",
    "inkscapeConnector-curvature": 0,
    d: "M58.9,56.505h0.354l0.318-0.494l0,0l0.312,0.494h0.374l-0.498-0.746 l0.458-0.682h-0.344l-0.29,0.456l0,0l-0.281-0.456H58.94l0.46,0.68L58.9,56.505z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g451",
    transform: "matrix(3.8059094,0,0,-3.8059094,226.42236,-151.29076)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path453",
    "inkscapeConnector-curvature": 0,
    fill: "none",
    stroke: "#1F1A17",
    strokeWidth: 0.719,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M0,0l37.44-37.2L74.64,0l-37.2,37.14L0,0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path499",
    "inkscapeConnector-curvature": 0,
    fill: "#DA251D",
    d: "M435.596-123.888h5.479v-20.096h-5.479V-123.888z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path501",
    "inkscapeConnector-curvature": 0,
    fill: "#DA251D",
    d: "M444.729-123.889l5.48,0.001v-20.096h-5.48V-123.889z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path503",
    "inkscapeConnector-curvature": 0,
    fill: "#DA251D",
    d: "M426.461-123.888h5.48v-20.096h-5.48V-123.888z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path3152",
    "inkscapeConnector-curvature": 0,
    sodipodiNodetypes: "ccccccccc",
    d: "M381.141-45.792l-19.273,0.001v4.98 h13.758c-5.166,6.271-8.123,13.424-8.873,21.453h5.736c0.057-3.726,0.818-7.654,2.307-11.787c1.45-4.132,3.565-7.483,6.345-10.053 L381.141-45.792z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g3036-1",
    transform: "matrix(0.54894223,0,0,0.54894223,135.92688,-104.21792)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path18-7",
    "inkscapeConnector-curvature": 0,
    d: "M410.378-168.796l-28.78,49.873c26.197,15.128,56.021,15.127,82.219,0 l-28.777-49.872c-0.185,0.122-0.37,0.246-0.555,0.368c-0.678,0.369-1.416,0.736-2.153,1.045c-0.737,0.308-1.475,0.614-2.274,0.861 c-0.801,0.246-1.537,0.43-2.338,0.614c-0.802,0.185-1.599,0.308-2.459,0.369c-0.801,0.062-1.662,0.123-2.522,0.123 c-0.86,0-1.66-0.062-2.523-0.122c-0.797-0.063-1.659-0.185-2.459-0.369c-0.8-0.185-1.599-0.368-2.337-0.615 c-0.8-0.247-1.538-0.492-2.274-0.861c-0.739-0.31-1.477-0.677-2.152-1.045C410.745-168.549,410.561-168.672,410.378-168.796z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20-4",
    "inkscapeConnector-curvature": 0,
    d: "M381.596-261.347c-26.197,15.127-41.079,40.957-41.078,71.211h57.558 c0-0.86,0.061-1.722,0.124-2.521c0.061-0.799,0.247-1.662,0.368-2.459c0.185-0.801,0.371-1.599,0.616-2.338 c0.246-0.799,0.491-1.536,0.859-2.275c0.309-0.738,0.678-1.476,1.046-2.151c0.37-0.677,0.8-1.355,1.23-2.031 c0.431-0.676,0.923-1.291,1.415-1.906s1.046-1.168,1.598-1.722c0.553-0.553,1.168-1.107,1.783-1.598 c0.615-0.493,1.229-0.985,1.906-1.414c0.492-0.309,0.983-0.615,1.477-0.922L381.596-261.347L381.596-261.347z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22-0",
    "inkscapeConnector-curvature": 0,
    d: "M463.816-261.347l-28.779,49.873c0.491,0.308,0.982,0.553,1.475,0.922 c0.676,0.431,1.292,0.922,1.907,1.414c0.615,0.492,1.167,1.046,1.783,1.599c0.555,0.554,1.107,1.169,1.601,1.722 c0.491,0.616,0.982,1.228,1.413,1.907c0.43,0.675,0.861,1.354,1.229,2.03c0.37,0.676,0.738,1.412,1.046,2.151 c0.308,0.74,0.614,1.477,0.861,2.275c0.244,0.801,0.429,1.537,0.614,2.337c0.185,0.799,0.31,1.599,0.37,2.46 c0.06,0.8,0.121,1.66,0.121,2.521h57.561C504.897-220.391,490.013-246.219,463.816-261.347z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle24-9",
    sodipodiRx: 16.419001,
    sodipodiRy: 16.419001,
    sodipodiCx: 251.858,
    sodipodiCy: 157.903,
    cx: 422.676,
    cy: -190.135,
    r: 16.419
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.21021e7216377620b74d574a9c28b990.svg";
export { ForwardRef as ReactComponent };